import { computed } from 'mobx';

export default class ServerModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: this.id,
      url: this.url,
      caption: this.caption,
      username: this.username,
      password: this.password,
      last_sync: this.last_sync,
    };
  }

  updateFromJson(json) {
    this.id = json.id;
    this.url = json.url;
    this.caption = json.caption;
    this.username = json.username;
    this.password = json.password;
    this.last_sync = json.last_sync;
  }
}



// WEBPACK FOOTER //
// ./src/models/SystemConfiguration/ServerModel.js